// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7559ab97","667":"91967c5b"}[chunkId] + ".chunk.js";
};